var map = {
	"./template.bet575": 1078,
	"./template.bet575.tsx": 1078,
	"./template.bet777": 2123,
	"./template.bet777.tsx": 2123,
	"./template.betblast": 2124,
	"./template.betblast.tsx": 2124,
	"./template.betstride": 2125,
	"./template.betstride.tsx": 2125,
	"./template.buffalobet": 2126,
	"./template.buffalobet.tsx": 2126,
	"./template.chromabet": 1079,
	"./template.chromabet.tsx": 1079,
	"./template.default": 124,
	"./template.default.tsx": 124,
	"./template.forsport": 1080,
	"./template.forsport.tsx": 1080,
	"./template.gigabet": 2127,
	"./template.gigabet.tsx": 2127,
	"./template.goldenbet888": 2128,
	"./template.goldenbet888.tsx": 2128,
	"./template.goldenrush": 2129,
	"./template.goldenrush.tsx": 2129,
	"./template.hyperbet": 1081,
	"./template.hyperbet.tsx": 1081,
	"./template.juicybet": 2130,
	"./template.juicybet.tsx": 2130,
	"./template.junglebet": 2131,
	"./template.junglebet.tsx": 2131,
	"./template.magnumbet": 1082,
	"./template.magnumbet.tsx": 1082,
	"./template.oldgill": 1083,
	"./template.oldgill.tsx": 1083,
	"./template.puntcity": 2020,
	"./template.puntcity.tsx": 2020,
	"./template.pyramidbet": 1084,
	"./template.pyramidbet.tsx": 1084,
	"./template.slambet": 2132,
	"./template.slambet.tsx": 2132,
	"./template.sterlingparker": 2133,
	"./template.sterlingparker.tsx": 2133,
	"./template.templebet": 2021,
	"./template.templebet.tsx": 2021,
	"./template.titanbet": 2134,
	"./template.titanbet.tsx": 2134,
	"./template.ts": 967,
	"./template.vikingbet": 2135,
	"./template.vikingbet.tsx": 2135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2415;